module.exports = __webpack_public_path__ + "img/line4.2f925382.svg";